import { useState } from "react";

function useLoading(initialValue = false) {
  const [loading, setLoading] = useState(initialValue);

  const start = () => {
    setLoading(true);
  };

  const stop = () => {
    setLoading(false);
  };

  return { loading, start, stop };
}

export default useLoading;
